import { Check, Copy, MessageCircle, Share2 } from "lucide-react";
import { useState } from "react";

export default function ShareActions({ url, text, title, idPrefix, label }) {
  const [copied, setCopied] = useState(false);
  const shareText = `${text} ${url}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      window.prompt("Link kopieren:", url);
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2200);
  };

  const nativeShare = () => navigator.share({ title, text, url }).catch(() => {});

  return (
    <div className="share-actions" data-testid={`${idPrefix}-share-bar`}>
      {label && <span className="mono-label">{label}</span>}
      <div className="share-actions-buttons">
        <button type="button" onClick={copyLink} data-testid={`${idPrefix}-copy-link-button`}>{copied ? <Check size={14} /> : <Copy size={14} />} {copied ? "Link kopiert" : "Link kopieren"}</button>
        <a href={`https://wa.me/?text=${encodeURIComponent(shareText)}`} target="_blank" rel="noreferrer" data-testid={`${idPrefix}-whatsapp-button`}><MessageCircle size={14} /> WhatsApp</a>
        {typeof navigator !== "undefined" && typeof navigator.share === "function" && <button type="button" onClick={nativeShare} data-testid={`${idPrefix}-native-share-button`}><Share2 size={14} /> Teilen</button>}
      </div>
      <input className="share-actions-url" readOnly value={url} onFocus={(event) => event.target.select()} aria-label="Teil-Link" data-testid={`${idPrefix}-share-url`} />
    </div>
  );
}
